import React from "react";
import { Link } from "react-router-dom";
import { setConsultSource } from "../lib/consultSource";

export default function MobileMenu({ open, links, onClose }) {
  if (!open) return null;
  return (
    <div className="xl:hidden bg-[#0c1729] border-t border-white/10">
      <div className="px-6 py-5 flex flex-col gap-4">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            onClick={onClose}
            className="font-serif text-lg text-white"
          >
            {l.label}
          </a>
        ))}
        <a href="#contact" onClick={() => { setConsultSource("Mobile menu"); onClose(); }} className="font-serif text-lg text-white" data-testid="mobile-schedule-consult">
          Schedule a Consult
        </a>
        <Link to="/pay" onClick={onClose} className="font-serif text-lg text-[#d4b87a]" data-testid="mobile-pay-online">
          Pay Online
        </Link>
      </div>
    </div>
  );
}
